import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './JMInversiones.css';
import BannerDesktop from '../assets/MOTOS_DESKTOP_BANNER.jpg.jpeg';
import BannerMobile from '../assets/MOTOS_MOBILE_BANNER.jpg.jpeg';

// Motos
import CruxNegro from '../assets/motos/Crux-Rev-Negro.png';
import CruxAqua from '../assets/motos/crux-aqua-1.png';
import BajajPlatina from '../assets/motos/BAJAJ.jpg';
import BajajPlatino from '../assets/motos/BAJAJ PLATINO.webp';
import TauroSupercubPng from '../assets/motos/TAURO SUPER CUB.png';
import TauroClub from '../assets/motos/TAURO CLUB.jpg';
import TauroFenix from '../assets/motos/484039018_9139723039488375_5827307589674743937_n.png';

// Pasolas
import AeroxGris from '../assets/pasola/AEROX_GRIS_xgks45.png';
import AeroxNeon from '../assets/pasola/aerox_neon.png';
import AeroxNeon2 from '../assets/pasola/aerox_neon_glwni8.png';
import XForce1 from '../assets/pasola/1_yamaha_x_force.jpeg';
import XForce2 from '../assets/pasola/2_yamahaforcex.jpg';
import Address110a from '../assets/pasola/suzuki-address-1.jpg';
import Address110b from '../assets/pasola/Address_black.jpg';
import Address110c from '../assets/pasola/210803_ad110_01.jpg';
import Address125a from '../assets/pasola/adrees.jpg';
import Address125b from '../assets/pasola/L_0301adrv125g200702.jpg';
import Address125c from '../assets/pasola/L_0301adv125gl200812.jpg';
import AddressS125a from '../assets/pasola/img_167_03.jpg';
import AddressS125b from '../assets/pasola/1_l.jpg';
import AddressS125c from '../assets/pasola/13868408540630_1200.jpg';
import Lets4a from '../assets/pasola/L_0301lets4sl200804.jpg';
import Lets4b from '../assets/pasola/L_01bdcb219e1f7320defcf930af.jpg';
import Lets4c from '../assets/pasola/L_0301lets4201105.jpg';
import Cygnusa from '../assets/pasola/CYGNUS.jpg';
import Cygnusb from '../assets/pasola/Yamaha-Cygnus-Gryphus-6.jpg';
import Cygnusc from '../assets/pasola/Yamaha-Cygnus-Gryphus-5.jpg';
import Tacta from '../assets/pasola/L_b3d9c411723b5777370379c196.jpg';
import Tactb from '../assets/pasola/L_dfb9faf87eaae3c2e69165aaa7.jpg';
import Tactc from '../assets/pasola/L_72bf797c4dbb157ddc0c2e92ea.jpg';
import Tactd from '../assets/pasola/L_8b35b7588a76cde1ad0261e8a2.jpg';
import Tacte from '../assets/pasola/HONDA-50-TACT.webp';

const motos = [
  { id: 1,  tipo: 'Motocicleta', nombre: 'Yamaha Crux',          imagenes: [CruxNegro, CruxAqua] },
  { id: 8,  tipo: 'Motocicleta', nombre: 'Platina Bajaj 125cc',  imagenes: [BajajPlatina, BajajPlatino] },
  { id: 9,  tipo: 'Motocicleta', nombre: 'Super Cub Tauro',      imagenes: [TauroSupercubPng, TauroClub] },
  { id: 10, tipo: 'Motocicleta', nombre: 'Tauro Fénix 105',      imagenes: [TauroFenix] },
  { id: 2,  tipo: 'Pasola',      nombre: 'Yamaha Aero',          imagenes: [AeroxGris, AeroxNeon, AeroxNeon2] },
  { id: 3,  tipo: 'Pasola',      nombre: 'Yamaha XForce',        imagenes: [XForce1, XForce2] },
  { id: 4,  tipo: 'Pasola',      nombre: 'Suzuki Address 110',   imagenes: [Address110a, Address110b, Address110c] },
  { id: 5,  tipo: 'Pasola',      nombre: 'Suzuki Address 125',   imagenes: [Address125a, Address125b, Address125c] },
  { id: 6,  tipo: 'Pasola',      nombre: 'Suzuki Address S 125', imagenes: [AddressS125a, AddressS125b, AddressS125c] },
  { id: 7,  tipo: 'Pasola',      nombre: "Suzuki Let's 4",       imagenes: [Lets4a, Lets4b, Lets4c] },
  { id: 11, tipo: 'Pasola',      nombre: 'Yamaha Cygnus',        imagenes: [Cygnusa, Cygnusb, Cygnusc] },
  { id: 12, tipo: 'Pasola',      nombre: 'Honda Tact',           imagenes: [Tacta, Tactb, Tactc, Tactd, Tacte] },
];

const pasos = [
  { num: '01', titulo: 'Elige tu modelo', desc: 'Selecciona la moto o pasola que se adapte a tus necesidades.' },
  { num: '02', titulo: 'Llena la solicitud', desc: 'Completa nuestra ficha de solicitud en línea. Simple y rápido.' },
  { num: '03', titulo: 'Aprobación rápida', desc: 'Revisamos tu solicitud y te contactamos en menos de 24 horas.' },
  { num: '04', titulo: '¡A rodar!', desc: 'Aprobado el financiamiento, recibe tu vehículo y disfrútalo.' },
];

const beneficios = [
  { icon: '⚡', titulo: 'Aprobación en 24h', desc: 'Proceso ágil sin tanto papeleo.' },
  { icon: '💰', titulo: 'Cuotas flexibles', desc: 'Pagos semanales, quincenales o mensuales.' },
  { icon: '🔒', titulo: 'Sin tarjeta de crédito', desc: 'No necesitas historial bancario.' },
  { icon: '🤝', titulo: 'Asesoría personalizada', desc: 'Un asesor te guía en todo el proceso.' },
];

function MotoCard({ moto }) {
  const [idx, setIdx] = useState(0);
  const total = moto.imagenes.length;

  useEffect(() => {
    if (total <= 1) return;
    const timer = setInterval(() => {
      setIdx(prev => (prev + 1) % total);
    }, 4000);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <div className="jm-moto-card">
      <div className="jm-moto-img-wrap">
        <img src={moto.imagenes[idx]} alt={moto.nombre} className="jm-moto-img" />
        {total > 1 && (
          <div className="jm-img-dots">
            {moto.imagenes.map((_, i) => (
              <span key={i} className={`jm-img-dot ${i === idx ? 'active' : ''}`} onClick={() => setIdx(i)} />
            ))}
          </div>
        )}
      </div>
      <span className="jm-moto-tipo">{moto.tipo}</span>
      <h3 className="jm-moto-nombre">{moto.nombre}</h3>
      <Link to="/solicitud-inversiones" className="jm-btn-solicitar">Solicitar →</Link>
    </div>
  );
}

export default function JMInversiones() {
  const [filtro, setFiltro] = useState('Todos');
  const categorias = ['Todos', 'Motocicleta', 'Pasola'];
  const motosFiltradas = filtro === 'Todos' ? motos : motos.filter(m => m.tipo === filtro);

  return (
    <div className="jm-page">

      {/* HERO BANNER */}
      <section className="jm-hero jm-hero--banner">
        <picture className="jm-banner-picture">
          <source media="(max-width: 768px)" srcSet={BannerMobile} />
          <source media="(min-width: 769px)" srcSet={BannerDesktop} />
          <img src={BannerDesktop} alt="JM Inversiones - Motos y Pasolas" className="jm-banner-img" />
        </picture>
        <div className="jm-hero-overlay">
          <div className="jm-hero-inner">
            <span className="jm-eyebrow">INVERSIONES JM MEJÍA SANTOS S.R.L.</span>
            <h1>Motores y Pasolas<br /><span> garantizamos tu dinero</span></h1>
            <p>Financiamientos de motores y pasolas con cuotas cómodas y aprobación rápida. Sin complicaciones.</p>
            <div className="jm-hero-btns">
              <Link to="/solicitud-inversiones" className="jm-btn-primary">Solicitar financiamiento →</Link>
              <a href="#catalogo" className="jm-btn-outline">Ver catálogo</a>
            </div>
            <div className="jm-hero-stats">
              <div className="jm-stat"><span className="jm-stat-num">+500</span><span className="jm-stat-label">Vehículos financiados</span></div>
              <div className="jm-stat-div"></div>
              <div className="jm-stat"><span className="jm-stat-num">24h</span><span className="jm-stat-label">Aprobación</span></div>
              <div className="jm-stat-div"></div>
              <div className="jm-stat"><span className="jm-stat-num">12</span><span className="jm-stat-label">Modelos disponibles</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section className="jm-section jm-beneficios-section">
        <div className="jm-container">
          <div className="jm-beneficios-grid">
            {beneficios.map((b, i) => (
              <div key={i} className="jm-beneficio-card">
                <div className="jm-beneficio-icon">{b.icon}</div>
                <h3>{b.titulo}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CATÁLOGO */}
      <section className="jm-section jm-catalogo-section" id="catalogo">
        <div className="jm-container">
          <div className="jm-section-header">
            <span className="jm-label">Nuestros modelos</span>
            <h2>Catálogo de <span>Motores y Pasolas</span></h2>
            <p>Elige el modelo que más te guste y fináncialo con nosotros.</p>
          </div>
          <div className="jm-filtros">
            {categorias.map(c => (
              <button key={c} className={`jm-filtro-btn ${filtro === c ? 'active' : ''}`} onClick={() => setFiltro(c)}>
                {c}
              </button>
            ))}
          </div>
          <div className="jm-catalogo-grid">
            {motosFiltradas.map(m => (
              <MotoCard key={m.id} moto={m} />
            ))}
          </div>
        </div>
      </section>

      {/* CÓMO FUNCIONA */}
      <section className="jm-section jm-pasos-section">
        <div className="jm-container">
          <div className="jm-section-header">
            <span className="jm-label">Proceso simple</span>
            <h2>¿Cómo <span>funciona</span>?</h2>
            <p>En 4 pasos sencillos tienes tu vehículo financiado.</p>
          </div>
          <div className="jm-pasos-grid">
            {pasos.map((p, i) => (
              <div key={i} className="jm-paso-card">
                <div className="jm-paso-num">{p.num}</div>
                <h3>{p.titulo}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* UBICACIONES */}
      <section className="jm-section jm-ubicacion-section">
        <div className="jm-container">
          <div className="jm-section-header">
            <span className="jm-label">Encuéntranos</span>
            <h2>Nuestras <span>Ubicaciones</span></h2>
            <p>Visítanos en cualquiera de nuestras sucursales o contáctanos directamente.</p>
          </div>
          
          <div className="jm-ubicacion-grid" style={{ marginBottom: '40px' }}>
            <div className="jm-ubicacion-info">
              
              {/* SUCURSAL MOCA */}
              <div className="jm-cnt-card">
                <div className="jm-cnt-icon">📍</div>
                <div>
                  <h3>Moca (Principal)</h3>
                  <p>Calle Sánchez esq. Sabana Larga<br />Moca, Espaillat<br />República Dominicana</p>
                </div>
              </div>

              {/* SUCURSAL TAMBORIL */}
              <div className="jm-cnt-card">
                <div className="jm-cnt-icon">📍</div>
                <div>
                  <h3>Tamboril (Sucursal)</h3>
                  <p>Tamboril: Calle Real No. 60, Carretera Tamboril<br />República Dominicana</p>
                </div>
              </div>

              {/* TELÉFONOS Y EXTENSIONES */}
              <div className="jm-cnt-card">
                <div className="jm-cnt-icon">📞</div>
                <div>
                  <h3>Teléfono Principal</h3>
                  <p><a href="tel:+18099359178">809-935-9178</a></p>
                  <p style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                    • Ext. <strong>1016</strong> — Moca<br />
                    • Ext. <strong>1017</strong> — Tamboril<br />
                    • Cel. Tamboril: <a href="tel:+18297571049">829-757-1049</a>
                  </p>
                </div>
              </div>

              {/* HORARIO */}
              <div className="jm-cnt-card">
                <div className="jm-cnt-icon">🕐</div>
                <div>
                  <h3>Horario de Atención</h3>
                  <p>Lunes — Viernes: 8:30 AM – 6:00 PM</p>
                  <p>Sábados: 8:30 AM – 4:00 PM</p>
                </div>
              </div>

              {/* BOTÓN WHATSAPP (Abre chat con el principal 809-935-9178) */}
              <a href="https://wa.me/18099359178?text=Hola%2C%20me%20interesa%20obtener%20informaci%C3%B3n%20sobre%20financiamiento." target="_blank" rel="noreferrer" className="jm-whatsapp-btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Escríbenos por WhatsApp
              </a>
            </div>

            {/* MAPAS DE GOOGLE MAPS */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', height: '100%' }}>
              
              {/* Mapa Moca */}
              <div className="jm-mapa-wrap" style={{ minHeight: '220px' }}>
                <div className="jm-mapa-label">📍 Moca: Calle Sánchez esq. Sabana Larga</div>
                <iframe
                  title="Ubicación Moca"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d961.4!2d-70.5234!3d19.3968!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eb17b1234567890%3A0x0!2s9FRC%2BHMR+Moca!5e0!3m2!1ses!2sdo!4v1234567890"
                  width="100%" height="100%"
                  style={{ border: 0 }}
                  allowFullScreen="" loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              {/* Mapa Tamboril */}
              <div className="jm-mapa-wrap" style={{ minHeight: '220px' }}>
                <div className="jm-mapa-label">📍 Tamboril: Calle Real No. 60, Carretera Tamboril</div>
                <iframe
                  title="Ubicación Tamboril"
                  src="https://maps.google.com/maps?q=19.482593536376953,-70.60575866699219&z=17&output=embed"
                  width="100%" height="100%"
                  style={{ border: 0 }}
                  allowFullScreen="" loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="jm-cta-section">
        <div className="jm-container">
          <div className="jm-cta-box">
            <div>
              <h2>¿Listo para tu <span>nueva moto</span>?</h2>
              <p>Completa la solicitud en línea y recibe respuesta en menos de 24 horas.</p>
            </div>
            <div className="jm-cta-btns">
              <Link to="/solicitud-inversiones" className="jm-cta-btn">Solicitar ahora →</Link>
              <a href="https://wa.me/18099359178" target="_blank" rel="noreferrer" className="jm-cta-btn-outline">
                📞 Contáctanos por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}